import { useNavigate } from "react-router-dom";
import { SpinnerCircular } from "spinners-react";
import {
  TCreateFormPayload,
  useAlreadyCreatedForms,
  useCreateForm,
  useServiceTypes,
} from "../../hooks/forms.hooks";
import FormConfigForm from "./Form";

export function AddFormConfig() {
  const { isFetching, isError } = useServiceTypes();
  const { isFetching: isFetching1, isError: isError1 } =
    useAlreadyCreatedForms();
  const { mutate } = useCreateForm();
  const navigate = useNavigate();

  const onSubmit = (payload: TCreateFormPayload) => {
    mutate(payload, {
      onSuccess: () => navigate("/form-configurations", { replace: true }),
    });
  };

  let toRender = null;
  if (isFetching || isFetching1 || isError || isError1) {
    toRender = (
      <div className="flex justify-center items-center p-8">
        {isError || isError1 ? (
          <p>Something went wrong while fetching info!</p>
        ) : (
          <SpinnerCircular />
        )}
      </div>
    );
  } else {
    toRender = (
      <FormConfigForm
        ctx="add"
        onSubmit={onSubmit}
        defaultValues={{ isNewForm: true, active: true, name: "", serviceName: "", type: "Service Form" }}
      />
    );
  }

  return <div>{toRender}</div>;
}
